(function ($) {
  $(function () {

    /*****
      Set some global variables
    *****/
    var template_url = $('#template_url').val();


    /*****
      iOS Viewport check
    *****/
    var isVHCheckNeeded = vhCheck();
    var hasVHCKeckValue = document.documentElement.style.getPropertyValue('--vh-offset');
    if (isVHCheckNeeded && hasVHCKeckValue) {
      $('body').addClass('use-ios-offset');
    }


    /*****
      Nav toggle
    *****/
    $('.site-menu-toggle').on('click', function (e) {
      e.preventDefault();
      $(this).toggleClass('is-active');
      $('html').attr('data-nav-state', $('html').attr('data-nav-state') == 'closed' ? 'open' : 'closed');
    });


    /*****
      Fancybox
      ---
      This is just sample code, to be extended
    *****/
    // $().fancybox({
    //   selector : '.video-lightbox',
    //   youtube : {
    //     controls: true,
    //     showinfo: false
    //   },
    //   hash: false,
    //   buttons: ['close'],
    //   infobar: false,
    //   idleTime: 300,
    //   loop: true
    // });
    //
    // $().fancybox({
    //   selector : '.image-lightbox',
    //   hash: false,
    //   buttons: ['close'],
    //   infobar: false,
    //   idleTime: 300,
    //   loop: true
    // });

  });
})(jQuery);
